export default __webpack_public_path__ + "static/media/20.ca57a56d.jpg";